/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignScrapeOnExistingCampaign } from '../../axios/campaignScrapeOnExistingCampaign'
import type {
	CampaignScrapeOnExistingCampaignError,
	CampaignScrapeOnExistingCampaignPathParams,
	CampaignScrapeOnExistingCampaignRequest,
	CampaignScrapeOnExistingCampaignResponse,
} from '../../types/CampaignScrapeOnExistingCampaign'

export const campaignScrapeOnExistingCampaignMutationKey = () => [{ url: '/campaigns/:campaign/scrape' }] as const

export type CampaignScrapeOnExistingCampaignMutationKey = ReturnType<typeof campaignScrapeOnExistingCampaignMutationKey>

export type CampaignScrapeOnExistingCampaignVariables = {
	campaign: CampaignScrapeOnExistingCampaignPathParams['campaign']
	data: CampaignScrapeOnExistingCampaignRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::scrapeOnExistingCampaign */
export function useCampaignScrapeOnExistingCampaign<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignScrapeOnExistingCampaignResponse,
		AxiosError<CampaignScrapeOnExistingCampaignError>,
		CampaignScrapeOnExistingCampaignVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignScrapeOnExistingCampaignMutationKey(),
		mutationFn: ({ campaign, data }: CampaignScrapeOnExistingCampaignVariables) =>
			campaignScrapeOnExistingCampaign(campaign, data, config).then(res => res.data),
		...options,
	})
}
